/**
 * Sidebar Intersection Observer
 *
 * Highlights active sidebar links based on scroll position.
 * Used by engines and integration pages.
 */

/**
 * Initialize sidebar observer to highlight active section links.
 *
 * @param {Object} options - Configuration options
 * @param {string} options.sectionSelector - CSS selector for sections (default: '.section')
 * @param {string} options.linkSelector - CSS selector for sidebar links (default: '.sidebar-nav a')
 * @param {string} options.activeClass - Class to add to active link (default: 'active')
 * @param {string} options.rootMargin - IntersectionObserver rootMargin (default: '-20% 0px -70% 0px')
 * @returns {IntersectionObserver} The created observer instance
 */
export function initSidebarObserver(options = {}) {
  const {
    sectionSelector = '.section',
    linkSelector = '.sidebar-nav a',
    activeClass = 'active',
    rootMargin = '-20% 0px -70% 0px'
  } = options;

  const sections = document.querySelectorAll(sectionSelector);
  const sidebarLinks = document.querySelectorAll(linkSelector);

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        sidebarLinks.forEach(link => {
          link.classList.toggle(activeClass, link.getAttribute('href') === '#' + id);
        });
      }
    });
  }, { root: null, rootMargin, threshold: 0 });

  sections.forEach(section => sectionObserver.observe(section));

  return sectionObserver;
}
